import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import './Navbar.css';

function Navbar({ scrollToTop }) {
  const [click, setClick] = useState(false);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const showLinks = () => {
    if (window.innerWidth >= 960) {
      setClick(false);
    }
  };

  useEffect(() => {
    window.addEventListener('resize', showLinks)

    return () => {
      window.removeEventListener('resize', showLinks)
    }
  }, [])

  return (
    <>
      <nav className="navbar">
        <div className="navbar-rect">
          <div className="navbar-container">
            {/* logo removed per request */}
            <div className="nav-actions">
              <a
                className="summary-button"
                href="https://drive.google.com/file/d/15iUMEWVh5fp-onURbp2oRDo1eAEYeEgp/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
              >
                COMPANY PROFILE
              </a>
            </div>
            <div className={click ? 'menu-icon active' : 'menu-icon'} onClick={handleClick} aria-hidden>
              {click ? <FaTimes size={20} /> : <FaBars size={20} />}
            </div>
            {click && <div className="mobile-overlay" onClick={closeMobileMenu} />}
            {/* Summary popup removed; button links directly to Drive PDF */}
            <ul className={click ? 'nav-menu nav-menu-active' : 'nav-menu'}>
              <li className="nav-item"><Link to='/' className="nav-links" onClick={() => { closeMobileMenu(); scrollToTop(); }}>Home</Link></li>
              <li className="nav-item"><Link to='/services' className="nav-links" onClick={() => { closeMobileMenu(); scrollToTop(); }}>Services</Link></li>
              <li className="nav-item"><Link to='/projects' className="nav-links" onClick={() => { closeMobileMenu(); scrollToTop(); }}>Projects</Link></li>
              <li className="nav-item"><Link to='/reviews' className="nav-links" onClick={() => { closeMobileMenu(); scrollToTop(); }}>Reviews</Link></li>
              <li className="nav-item"><Link to='/send-message' className="nav-links" onClick={() => { closeMobileMenu(); scrollToTop(); }}>Send Message</Link></li>
              {/* <li className="nav-item"><Link to='/contact' className="nav-links" onClick={() => { closeMobileMenu(); scrollToTop(); }}>Contact</Link></li> */}
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Navbar;
